import { toast } from '../context/CustomToastContext';
import apiClient from "../network/apiClient";

class contactusApiProvider {
  async contactus(input) {
    try {
      const response = await apiClient.post("contact-us", input);
      console.log("response:", response)
      if (response.data && (response.status === 200 || response.status === 201)) {
        toast.success(response.data.message || "Thank you for contacting us!");
        return {
          status: response.status,
          response: response.data
        };
      } else {
        toast.error(response.data?.message || "Something went wrong")
        return {
          status: false,
          response: []
        };
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return {
        status: false,
        response: []
      };
    }
  }
}
const apiContactUs = new contactusApiProvider()
export default apiContactUs